import { useMediaQuery } from './use-media-query';

const BREAKPOINTS = {
    xs: 480,
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    '2xl': 1536,
} as const;

type Breakpoint = keyof typeof BREAKPOINTS;

export function useBreakpointDown(breakpoint: Breakpoint = 'md') {
    // Mirrors the Tailwind `md:`-style query exactly and negates, so the boundary can't drift.
    return !useMediaQuery(`(width >= ${BREAKPOINTS[breakpoint]}px)`);
}
